export const symbolsCat = {
  "translation": {
    "Regel van Benedictus": "Rule of St Benedict",
    "Regel van Augustinus": "Rule of St Augustine",
    "Franciscaanse regels": "Franciscan Rules",
    "Geestelijke ridderorden": "Knightly Rules",
    "Overige": "Remaining Rules",
    "Zonder erkende of bekende regel": "Without acknowledged or known rule",
    "Kapittels": "Collegiate Churches"
  },
  "data": {
    "Kapittels": {
      "kapittel": {
        "symbol": "church",
        "en": "Collegiate Church"
      }
    },
    "Regel van Benedictus": {
      "benedictijnen": {
        "symbol": "square_m_0",
        "en": "Benedictines"
      },
      "benedictinessen": {
        "symbol": "square_f_0",
        "en": "Benedictine Nuns"
      },
      "benedictijnen en benedictinessen": {
        "symbol": "square_d_0",
        "en": "Benedictine Monks and Nuns"
      },
      "cisterciënzers": {
        "symbol": "circle_m_0",
        "en": "Cistercians"
      },
      "cisterciënzerinnen": {
        "symbol": "circle_f_0",
        "en": "Cistercian Nuns"
      },
      "cisterciënzer dubbelklooster": {
        "symbol": "circle_d_0",
        "en": "Cistercian Monks and Nuns"
      },
      "wilhelmieten": {
        "symbol": "diamond_m_0",
        "en": "Hermits of St William"
      }
    },
    "Regel van Augustinus": {
      "antonieten": {
        "symbol": "Tshape_m_1",
        "en": "Antonines"
      },
      "augustijner eremieten": {
        "symbol": "rectV_m_1",
        "en": "Austin Friars"
      },
      "birgitten en birgittinessen": {
        "symbol": "triangleDown_d_1",
        "en": "Bridgettine Brethren and Sisters"
      },
      "cellebroeders": {
        "symbol": "star_m_1",
        "en": "Alexians"
      },
      "cellezusters": {
        "symbol": "star_f_1",
        "en": "Alexian Sisters"
      },
      "dominicanen": {
        "symbol": "diamond_m_1",
        "en": "Dominicans"
      },
      "dominicanessen": {
        "symbol": "diamond_f_1",
        "en": "Dominicanesses"
      },
      "eksterbroeders": {
        "symbol": "rectV_m_1",
        "en": "Pied Friars"
      },
      "hospitaalzusters": {
        "symbol": "starSix_f_1",
        "en": "Hospital Sisters"
      },
      "kruisheren": {
        "symbol": "triangleUp_m_1",
        "en": "Crutched Friars"
      },
      "lazarieten": {
        "symbol": "Lshape_m_1",
        "en": "Knights of St Lazarus"
      },
      "magdalenen": {
        "symbol": "ellipse_f_1",
        "en": "Magdalenes"
      },
      "norbertijnen": {
        "symbol": "square_m_1",
        "en": "Premonstratensians"
      },
      "norbertinessen": {
        "symbol": "square_f_1",
        "en": "Premonstratensian Canonesses"
      },
      "norbertijnen en norbertinessen": {
        "symbol": "square_d_1",
        "en": "Premonstratensian Canons and Canonesses"
      },
      "regulieren": {
        "symbol": "circle_m_1",
        "en": "Canons Regular"
      },
      "regulieren van Windesheim": {
        "symbol": "circleW_m_1",
        "en": "Canons Regular of Windesheim"
      },
      "regulieren van Sion": {
        "symbol": "circleS_m_1",
        "en": "Canons Regular of Sion"
      },
      "regularissen": {
        "symbol": "circle_f_1",
        "en": "Canonesses Regular"
      },
      "regularissen van Windesheim": {
        "symbol": "circleW_f_1",
        "en": "Canonesses Regular of Windesheim"
      },
      "regularissen van Sion": {
        "symbol": "circleS_f_1",
        "en": "Canonesses Regular of Sion"
      },
      "regularissen van Venlo": {
        "symbol": "circleV_f_1",
        "en": "Canonesses Regular of Venlo"
      },
      "sepulcrijnen": {
        "symbol": "Ishape_m_1",
        "en": "Canons Regular of the Holy Sepulchre"
      },
      "sepulcrinessen": {
        "symbol": "Ishape_f_1",
        "en": "Canonesses Regular of the Holy Sepulchre"
      },
      "victorinnen": {
        "symbol": "cross_f_1",
        "en": "Canonesses Regular of St Victor"
      },
      "zakbroeders": {
        "symbol": "rectVhat_m_1",
        "en": "Friars of the Sack"
      },
      "regulieren en regularissen": {
        "symbol": "circle_d_1",
        "en": "Canons and Canonesses Regular"
      },
      "ursulinen": {
        "symbol": "rectVbot_f_1",
        "en": "Ursulines"
      }
    },
    "Franciscaanse regels": {
      "franciscanen": {
        "symbol": "square_m_2",
        "en": "Friars Minor"
      },
      "clarissen": {
        "symbol": "circle_f_2",
        "en": "Clarisses"
      },
      "tertianen": {
        "symbol": "triangleUp_m_2",
        "en": "Male Tertiaries"
      },
      "tertiarissen": {
        "symbol": "triangleUp_f_2",
        "en": "Tertiaries"
      },
      "tertianen en tertiarissen": {
        "symbol": "triangleUp_d_2",
        "en": "Male and Female Tertiaries"
      },
      "observante franciscanen": {
        "symbol": "star_m_2",
        "en": "Observant Franciscans"
      },
      "capucijnen": {
        "symbol": "diamond_m_2",
        "en": "Capucins"
      },
      "recollecten": {
        "symbol": "cross_m_2",
        "en": "Recollecten"
      },
      "broeders penitenten": {
        "symbol": "Ishape_m_2",
        "en": "Brothers penitents"
      },
      "penitenten recollectinen": {
        "symbol": "Tshape_f_2",
        "en": "Penitents recollectines"
      },
      "annunciaten": {
        "symbol": "Lshape_f_2",
        "en": "Sisters of the Annunciation"
      }
    },
    "Geestelijke ridderorden": {
      "tempeliers": {
        "symbol": "square_m_3",
        "en": "Knights Templars"
      },
      "johannieters": {
        "symbol": "circle_m_3",
        "en": "Knights Hospitallers"
      },
      "johannieter nonnen": {
        "symbol": "circle_f_3",
        "en": "Hospitaller Nuns"
      },
      "johannieter dubbelklooster": {
        "symbol": "circle_d_3",
        "en": "Hospitaller Knights and Nuns"
      },
      "Duitse Orde": {
        "symbol": "triangleUp_m_3",
        "en": "Teutonic Order"
      },
      "vrouwenconvent van de Duitse Orde": {
        "symbol": "triangleUp_f_3",
        "en": "Teutonic Order women convent"
      }
    },
    "Overige": {
      "kartuizers": {
        "symbol": "square_m_4",
        "en": "Carthusians"
      },
      "karmelieten": {
        "symbol": "circle_m_4",
        "en": "Carmelites"
      },
      "karmelitessen": {
        "symbol": "circle_f_4",
        "en": "Carmelite Sisters"
      },
      "caulieten": {
        "symbol": "star_m_4",
        "en": "Caulites"
      },
      "monialen": {
        "symbol": "rectV_f_4",
        "en": "Moniales"
      },
      "tertiarissen van Sint Dominicus": {
        "symbol": "triangleUp_f_4",
        "en": "Tertiaries of St Dominicus"
      },
      "seculiere kanunniken": {
        "symbol": "diamond_m_4",
        "en": "Secular Canons (with Aachen Rule)"
      },
      "jezuïeten": {
        "symbol": "Ishape_m_4",
        "en": "Jesuits"
      },
      "ongeschoeide karmelitessen": {
        "symbol": "Lshape_f_4",
        "en": "Discalced Carmelite Sisters"
      },
      "overig": {
        "symbol": "Tshape_f_4",
        "en": "Other"
      }
    },
    "Zonder erkende of bekende regel": {
      "begarden": {
        "symbol": "circle_m_5",
        "en": "Beghards"
      },
      "begijnen": {
        "symbol": "circle_f_5",
        "en": "Beguines"
      },
      "broeders des gemenen levens": {
        "symbol": "triangleUp_m_5",
        "en": "Brethren of the Common Life"
      },
      "zusters des gemenen levens": {
        "symbol": "triangleUp_f_5",
        "en": "Sisters of the Common Life"
      },
      "gemeenschap van devote priesters": {
        "symbol": "ellipse_m_5",
        "en": "Community of Priests"
      },
      "hospitaalzusters*": {
        "symbol": "starSix_f_5",
        "en": "Hospital Sisters"
      },
      "hospitaalbroeders en -zusters": {
        "symbol": "starSix_d_5",
        "en": "Hospital Brethren and Sisters"
      },
      "bekeerde vrouwen": {
        "symbol": "rectV_f_5",
        "en": "Converted Women"
      },
      "broeders": {
        "symbol": "square_m_5",
        "en": "Brethren"
      },
      "zusters": {
        "symbol": "square_f_5",
        "en": "Sisters"
      },
      "broeders en zusters": {
        "symbol": "square_d_5",
        "en": "Brethren and Sisters"
      },
      "cellebroeders*": {
        "symbol": "star_m_5",
        "en": "Alexians without known rule"
      },
      "cellezusters*": {
        "symbol": "star_f_5",
        "en": "Alexian Sisters without known rule"
      },
      "monniken": {
        "symbol": "Lshape_m_5",
        "en": "Monks (undetermined)"
      },
      "seculiere kanunniken*": {
        "symbol": "diamond_m_5",
        "en": "Secular Canons"
      },
      "seculiere kanunnikessen": {
        "symbol": "diamond_f_5",
        "en": "Secular Canonesses"
      },
      "vicarissen": {
        "symbol": "Ishape_f_5",
        "en": "Convent of Chantry Priests"
      }
    }
  }
};

let ext='.svg';
if (window.document.documentMode) {
  // Do IE stuff
  ext='.png';
}

let s = {};
for (var category in symbolsCat.data) {
  for (var order in symbolsCat.data[category]) {
    s[order] = symbolsCat.data[category][order].symbol + ext;
  }
}
export const symbols=s;
export const plain_symbols={
  'klooster': 'plain/klooster' + ext,
  'uithof': 'plain/uithof' + ext,
  'kapittel': 'plain/kapittel' + ext,
};